const state = {
  musicVolume: 0.15,
  soundVolume: 0.7,
  isMusicMuted: false,
  isSoundMuted: false,
  currentMusic: null,
  currentSound: null,
  currentMusicInfo: null,
  isPlaying: false, // Add this new state
  autoplayFailed: false, // Add this new state
  isInitialized: false, // Add this new state

  // Separate music playlists from sound effects
  musicPlaylists: {
    ambient: [
        {
            "path": "/music/a-villain39s-redemption-12976.mp3",
            "title": "A Villains Redemption",
            "artist": "Artista Desconhecido"
        },
        {
            "path": "/music/bossa-nova-summer-instrumental-brazil-7969.mp3",
            "title": "Bossa Nova Summer Instrumental Brazil",
            "artist": "AlexiAction"
        },
        {
            "path": "/music/caribbean-dream-126301.mp3",
            "title": "Caribbean Dream",
            "artist": "Tracy Thai"
        },
        {
            "path": "/music/for-her-chill-upbeat-summel-travel-vlog-and-ig-music-royalty-free-use-202298.mp3",
            "title": "For Her Chill Upbeat Summel Travel Vlog And Ig Music Royalty Free Use",
            "artist": "Summer Vibes"
        },
        {
            "path": "/music/fundo-musical-relaxante-para-meditacao-120658.mp3",
            "title": "Fundo Musical Relaxante Para Meditacao",
            "artist": "Artista Desconhecido"
        },
        {
            "path": "/music/gentle-bluegrass-country-folk-x27daisy-chainx27-203460.mp3",
            "title": "Gentle Bluegrass Country Folk Xdaisy Chain",
            "artist": "Daisy Chain"
        },
        {
            "path": "/music/just-in-time-174948.mp3",
            "title": "Just In Time",
            "artist": "Time Keepers"
        },
        {
            "path": "/music/morning-garden-acoustic-chill-15013.mp3",
            "title": "Morning Garden Acoustic Chill",
            "artist": "Olexy"
        },
        {
            "path": "/music/reggae-youtube-podcast-foolish-pride-brotheration-reggae-2021-135991.mp3",
            "title": "Reggae Youtube Podcast Foolish Pride Brotheration Reggae",
            "artist": "Brotheration"
        },
        {
            "path": "/music/rio-at-night-brazilian-dance-and-party-music-9617.mp3",
            "title": "Rio At Night Brazilian Dance And Party Music",
            "artist": "Brazilian Groove"
        },
        {
            "path": "/music/sedative-110241.mp3",
            "title": "Sedative",
            "artist": "Artista Desconhecido"
        },
        {
            "path": "/music/simple-acoustic-folk-138360.mp3",
            "title": "Simple Acoustic Folk",
            "artist": "Artista Desconhecido"
        },
        {
            "path": "/music/son-montuno-cuban-piano-music-1309.mp3",
            "title": "Son Montuno Cuban Piano Music",
            "artist": "Cuban Masters"
        },
        {
            "path": "/music/trip-to-home-relaxing-acoustic-guitar-background-music-7625.mp3",
            "title": "Trip To Home Relaxing Acoustic Guitar Background Music",
            "artist": "Acoustic Dreams"
        },
        {
            "path": "/music/water-161101.mp3",
            "title": "Water",
            "artist": "Artista Desconhecido"
        },
        {
            "path": "/music/western-rock-country-132231.mp3",
            "title": "Western Rock Country",
            "artist": "Country Roads"
        }
    ],
    battle: [
      {
        path: '/music/battle1.mp3',
        title: 'Battle 1',
        artist: 'Unknown'
      },
      {
        path: '/music/battle2.mp3',
        title: 'Battle 2',
        artist: 'Unknown'
      }
    ]
  },

  // Separate sound effects configuration
  soundEffects: {
    chest: {
      open: '/sounds/chest_open.mp3',
      close: '/sounds/chest_close.mp3'
    },
    fishing: {
        ambientSoundPierAndBeach: '/sounds/fishing/ambient_fishing.mp3',
        ambientOpenSea: '/sounds/fishing/ambient_fishing2.mp3',
        ambientSoundOthers: '/sounds/fishing/fishing_reel.mp3',
        catch: '/sounds/fishing/fishing_get_fish.mp3',
        fail: '/sounds/fishing/fishing_fail.mp3',
        firstFishDay: '/sounds/fishing/achievement_unlocked.mp3' // Added new sound for first fish of day
    },
    premiumItens: {
        drinkTonic: '/sounds/premiumItems/drink_tonic.mp3',
        chestOpen: '/sounds/premiumItems/chest_open.mp3',
        legendaryItem: '/sounds/premiumItems/legendary.mp3',
        getReward: '/sounds/premiumItems/chime.mp3'
    },
    ui: {
      click: '/sounds/ui_click.mp3',
      hover: '/sounds/ui_hover.mp3',
      success: '/sounds/ui_success.mp3',
      error: '/sounds/ui_error.mp3'
    },
    rewards: {
      coins: '/sounds/reward_coins.mp3',
      item: '/sounds/reward_item.mp3',
      levelUp: '/sounds/level_up.mp3'
    },
    roulette: {
        spin: '/sounds/roulette/roulette_spin.mp3',
        win: '/sounds/roulette/roulette_win.mp3',
    },
    shop: {
        buy: '/sounds/shop/cash-register-purchase.mp3',
        sell: '/sounds/shop/shop_sell.mp3',
        changeBuy: '/sounds/shop/cha-ching.mp3',
        buyPremiumItem: '/sounds/shop/buy-premium-item.mp3'
    }
  }
}

const getters = {
  effectiveMusic: state => {
    return state.isMusicMuted ? 0 : state.musicVolume
  },
  effectiveSound: state => {
    return state.isSoundMuted ? 0 : state.soundVolume
  }
}

const mutations = {
  SET_MUSIC_VOLUME(state, volume) {
    state.musicVolume = volume
  },
  SET_SOUND_VOLUME(state, volume) {
    state.soundVolume = volume
  },
  TOGGLE_MUSIC_MUTE(state) {
    state.isMusicMuted = !state.isMusicMuted
  },
  TOGGLE_SOUND_MUTE(state) {
    state.isSoundMuted = !state.isSoundMuted
  },
  SET_CURRENT_MUSIC(state, music) {
    state.currentMusic = music
  },
  SET_CURRENT_SOUND(state, sound) {
    state.currentSound = sound
  },
  SET_CURRENT_MUSIC_INFO(state, info) {
    state.currentMusicInfo = info
  },
  SET_PLAYING_STATE(state, isPlaying) {
    state.isPlaying = isPlaying
  },
  SET_AUTOPLAY_FAILED(state, value) {
    state.autoplayFailed = value
  },
  SET_INITIALIZED(state, value) {
    state.isInitialized = value
  }
}

const actions = {
  /**
   * Toca um efeito, e NUNCA lança nem espera o som começar.
   *
   * O iOS (todo navegador de iPhone é WebKit) recusa `play()` de um `new Audio()` que não nasce
   * dentro do toque do jogador — e o som de captura toca ~12 s depois do toque. Com `await
   * audio.play()`, a recusa (`NotAllowedError`) subia até o `catch` da pescaria, que jogava fora o
   * peixe que o servidor já tinha registrado: no iPhone a pesca "não funcionava" desde sempre.
   * Som é enfeite; quem chama esta ação não pode depender dele.
   */
  async playSound({ state, getters }, { category, type, returnAudio = false }) {
    if (state.isSoundMuted) return

    const soundPath = state.soundEffects[category]?.[type]
    if (!soundPath) return

    let audio
    try {
      audio = new Audio(soundPath)
      audio.volume = getters.effectiveSound
      const tocando = audio.play()
      if (tocando && typeof tocando.catch === 'function') tocando.catch(() => {})
    } catch (e) {
      return
    }

    // Retorna o áudio se returnAudio for true
    if (returnAudio) {
      return audio;
    }
  },

  async playMusic({ state, getters, commit, dispatch }, { category, index = null, startPaused = false }) {
    try {
      if (state.currentMusic) {
        state.currentMusic.pause()
        commit('SET_PLAYING_STATE', false)
      }

      const playlist = state.musicPlaylists[category] // Changed from playlist to musicPlaylists
      if (!playlist?.length) return

      const musicIndex = index !== null ? index : Math.floor(Math.random() * playlist.length)
      const musicTrack = playlist[musicIndex]
      const audio = new Audio(musicTrack.path)
      audio.volume = getters.effectiveMusic
      audio.loop = false // Changed to false to enable playlist functionality

      // Add ended event listener to play next song
      audio.addEventListener('ended', () => {
        dispatch('switchMusic', 'next')
      })

      commit('SET_CURRENT_MUSIC', audio)
      commit('SET_CURRENT_MUSIC_INFO', { 
        category, 
        index: musicIndex,
        title: musicTrack.title,
        artist: musicTrack.artist
      })

      if (!startPaused && state.isInitialized) {
        await audio.play()
        commit('SET_PLAYING_STATE', true)
      }
    } catch (error) {
      console.warn('Music playback failed:', error)
      commit('SET_PLAYING_STATE', false)
    }
  },

  async switchMusic({ state, dispatch }, direction = 'next') {
    if (!state.currentMusic || !state.currentMusicInfo) return

    const { category, index } = state.currentMusicInfo
    const playlist = state.musicPlaylists[category] // Changed from playlist to musicPlaylists
    
    let newIndex
    if (direction === 'next') {
      newIndex = (index + 1) % playlist.length
    } else {
      newIndex = (index - 1 + playlist.length) % playlist.length
    }

    await dispatch('playMusic', { category, index: newIndex })
  },

  updateVolumes({ state, getters }) {
    if (state.currentMusic) {
      state.currentMusic.volume = getters.effectiveMusic
    }
  },

  stopMusic({ state, commit }) {
    if (state.currentMusic) {
      state.currentMusic.pause()
      commit('SET_CURRENT_MUSIC', null)
      commit('SET_PLAYING_STATE', false)
    }
  },

  pauseMusic({ state, commit }) {
    if (state.currentMusic && !state.currentMusic.paused) {
      state.currentMusic.pause()
      commit('SET_PLAYING_STATE', false)
    }
  },

  async resumeMusic({ state, commit }) {
    if (state.currentMusic && state.currentMusic.paused) {
      await state.currentMusic.play()
      commit('SET_PLAYING_STATE', true)
    }
  },

  initializeAudio({ commit }) {
    commit('SET_INITIALIZED', true)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
